import { render, staticRenderFns } from "./DataExecute.vue?vue&type=template&id=2fc3795f&scoped=true"
import script from "./DataExecute.vue?vue&type=script&lang=js"
export * from "./DataExecute.vue?vue&type=script&lang=js"
import style0 from "./DataExecute.vue?vue&type=style&index=0&id=2fc3795f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3795f",
  null
  
)

export default component.exports